import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';

// Charger les ressources depuis des fichiers JSON par langue
const resources = {
  en: { translation: en },
  fr: { translation: fr }
};

// Détecter une langue passée via ?lang=... (en plus de ?lng=...)
let urlLang;
try {
  const params = new URLSearchParams(window.location.search);
  urlLang = params.get('lang') || params.get('lng') || undefined;
} catch (_) {}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    supportedLngs: ['en', 'fr'],
    interpolation: { escapeValue: false },
    detection: {
      // Détecter depuis l'URL (?lng=, ?lang=), le path (/en), le localStorage ou le navigateur
      order: ['querystring', 'path', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lng',
      lookupFromPathIndex: 0
    }
  });

// Si ?lang est présent, on force immédiatement cette langue (priorité URL)
if (urlLang && i18n.language !== urlLang) {
  i18n.changeLanguage(urlLang);
}

export default i18n;


